import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import SectionTitle from '../PageSectionTitle';
const DecisionningErrorTile = () => {
    const { t } = useTranslation('shared');
    return (_jsxs("main", { className: "general-message", children: [_jsx(SectionTitle, { title: t('common.AnalysisInProgress') }), _jsx("h3", { children: t('common.errorObtainingCreditReport') })] }));
};
export default DecisionningErrorTile;
